<template>
    <div class="dc-user-full is-net">
        <h2>{{$t('views.createUserFull.net.mainTitle')}}</h2>
        <div class="dc-user-full__btns">
            <el-button
            v-for="key in allKeys" :key="key"
            :class="{'is-selected': selectedKeys[key]}"
            size="default" @click="tapKey(key)">{{$t(`views.createUserFull.net.${key}`)}}</el-button>
        </div>
        <el-button class="dc-user-full__btn-next" :disabled="Object.keys(selectedKeys).length == 0" type="primary" size="default" @click="onNext">{{$t('views.createUserFull.btnNext')}}</el-button>
    </div>
</template>

<script>
import Services from '../../services';

export default {
    name: 'userFullNet',
    data () {
        return {
            allKeys: [
                'd500kless',
                'd1m',
                'd3m',
                'd5m',
                'd10m',
                'd10mmore',
                'nosay',
            ],
            selectedKeys: {},
        }
    },
    methods: {
        tapKey (key) {
            this.selectedKeys = {}
            this.$set(this.selectedKeys, key, true)
        },
        onNext () {
            let net = {
                selectedKeys: this.selectedKeys || {},
            }
            let old = this.$gb.userFulled || {}
            old.net = net
            this.$gb.userFulled = old
            Services.postUserEdit({
                full_info: old
            }).then(() => {
                
            }).finally(()=>{
                this.$router.push('/browse')
            })
        },
    }
}
</script>